/**
 * Enhances a query object with safe pagination defaults.
 * - If `offset` is nullish, defaults to 0.
 * - If `max` is nullish, defaults to 10.
 *
 * Preserves all other properties in the original query.
 *
 * @example
 * withPagination({ q: 'pop', offset: undefined, max: 20 })
 * // => { q: 'pop', offset: 0, max: 20 }
 */
export const withPagination = <T extends { offset?: number; max?: number }>(
  query: T,
) => ({
  ...query,
  offset: query.offset ?? 0,
  max: query.max ?? 10,
});
